/*
 * buzzwoo: correct Dawn's focus trap in accordion mode.
 *
 * MenuDrawer.onSummaryClick (assets/global.js) calls trapFocus() on the opened submenu. That
 * is right for the sliding panel, which covers the rest of the drawer, but wrong once the
 * panel opens inline: the surrounding rows stay on screen, so the keyboard has to be able to
 * reach them. Worse, the trap's first focusable element is the back button, which accordion
 * mode hides — Tab on the last submenu item then calls focus() on a hidden element and the
 * keyboard is stuck for good.
 *
 * The trap is re-pointed at the whole drawer rather than dropped, so focus still cannot
 * escape into the page behind. global.js itself is left untouched so Dawn updates do not
 * overwrite the fix.
 *
 * Timing: Dawn installs its trap inside a setTimeout(..., 100) when motion is reduced, but
 * defers it to the panel's transitionend otherwise. Both are covered below — the transitionend
 * handler defers by a tick because Dawn registered its own listener first, and the 600ms
 * timer is the backstop for browsers that never fire the transition.
 */
(() => {
  const TOGGLES = '.bw-drawer--accordion .bw-menu-row__toggle, .bw-drawer--accordion summary.menu-drawer__menu-item';

  function retrap(drawer) {
    if (!drawer || !drawer.closest('details[open]')) return;
    if (typeof trapFocus !== 'function') return;

    // Keep focus where it is; trapFocus() would otherwise pull it back to its second argument.
    const active = document.activeElement;
    const focusTarget = active && drawer.contains(active) ? active : drawer;
    trapFocus(drawer, focusTarget);
  }

  function scheduleRetrap(drawer, panel) {
    setTimeout(() => retrap(drawer), 150);
    setTimeout(() => retrap(drawer), 600);

    if (panel) {
      panel.addEventListener(
        'transitionend',
        () => setTimeout(() => retrap(drawer), 0),
        { once: true }
      );
    }
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(TOGGLES);
    if (!toggle) return;

    scheduleRetrap(toggle.closest('.bw-drawer--accordion'), toggle.nextElementSibling);
  });

  // Escape routes through MenuDrawer.closeSubmenu, which re-traps on the ancestor <details>
  // and hits the same hidden-back-button problem.
  document.addEventListener('keyup', (event) => {
    if (event.code !== 'Escape') return;

    const drawer = event.target.closest && event.target.closest('.bw-drawer--accordion');
    if (drawer) scheduleRetrap(drawer, null);
  });
})();
